function getStatusForVideo(video: any, VIDEO_STATUSES: any) {
  const { outputs, storyboard = null, isStoryboardApproved } = video;

  if (outputs.some((output) => output.status.name === 'DRAFT')) {
    return VIDEO_STATUSES.DRAFT;
  }

  if (
    (!isStoryboardApproved &&
      storyboard &&
      ['PENDING_REVIEW'].includes(storyboard.status.name)) ||
    outputs.some((output) =>
      ['PENDING_REVIEW', 'PENDING_SOCIAL_REVIEW', 'COST_REVIEW'].includes(
        output.status.name
      )
    )
  ) {
    return VIDEO_STATUSES.AWAITING_ACTION;
  }

  const baseStatus = outputs.some((output) =>
    ['SIGN_OFF_FINAL'].includes(output.status.name)
  )
    ? VIDEO_STATUSES.SIGN_OFF_FINAL
    : null;

  if (
    video?.permissions?.includes('APPROVE') &&
    baseStatus?.name === 'SIGN_OFF_FINAL'
  ) {
    return VIDEO_STATUSES.AWAITING_ACTION;
  }

  if (outputs.every((output) => ['APPROVED'].includes(output.status.name))) {
    return VIDEO_STATUSES.COMPLETE;
  }

  if (outputs.some((output) => ['ON_HOLD'].includes(output.status.name))) {
    return VIDEO_STATUSES.ON_HOLD;
  }

  if (
    outputs.some((output) => ['SIGN_OFF_FINAL'].includes(output.status.name))
  ) {
    return VIDEO_STATUSES.SIGN_OFF_FINAL;
  }

  return VIDEO_STATUSES.IN_PROGRESS;
}

export default getStatusForVideo;
